<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت واریزی تنخواه برای '{{inner_User.name}} {{inner_User.familly}}'</h5>
      <form [formGroup]="FundsForm" (submit)="OnSubmit()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-4">
            <label for="exampleInputEmail1"> مبلغ واریزی (ريال) </label>
            <input formControlName="Price" (keyup)="pishPardakht_Change()" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">مبلغ واریزی (ريال) را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-8">
            <label for="exampleInputEmail1">مبلغ واریزی (به حروف) </label>
            <input formControlName="PriceAlpah" disabled type="text" class="form-control">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">تاریخ واریز</label>
            <input type="text" formControlName="Date"  #datepickerBuy placeholder="اینجا تایپ کنید ..."   class="form-control" />
            <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerBuy"></ng-persian-datepicker>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">شرح</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">شرح را وارد نمائید.</small>
          </div>

        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!FundsForm.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
      </form>

      <br/>
      <hr/>
      <br/>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>مبلغ واریزی (ريال)</th>
              <th>تاریخ واریز</th>
              <th>شرح</th>
              <th>ایجاد کننده</th>
              <th>ناریخ</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_Funds.length
                      }
            ">
             <td>{{DataList_Funds.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
             <td>{{item.price | number}}</td>
             <td>{{item.price_date}}</td>
             <td>{{item.dsc}}</td>
             <td>{{item.username}}</td>
             <td>{{item.subdate}}</td>

              <td>
                <div class="btn-group " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.del" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                  </div>

                  <div *ngIf="item.del" >
                    <p style="color: red;">حذف شده است</p>
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>


     <pagination-controls
     id="DataList_UserTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>


  </div>
</div>


<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف اطلاعات واریز شناسه '{{Data_Seleted_Delete.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>
